import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Box, Card, Typography, Button } from "@mui/material";
import { Spa, ArrowForward } from "@mui/icons-material";
import { AssistantChat } from "./AssistantChat";
import { BetaFeatureChip } from "../../shared-components/BetaFeature";

export const AssistantInlineCard = ({
  context,
  title = "Bud",
  height = 500,
}) => {
  const navigate = useNavigate();
  const [conversationId, setConversationId] = useState(null);

  const handleExpand = () => {
    navigate(
      conversationId
        ? `/assistant?conversation=${conversationId}`
        : "/assistant",
    );
  };

  return (
    <Card
      variant="shadow"
      sx={{
        height,
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          p: 1.5,
          borderBottom: 1,
          borderColor: "divider",
          backgroundColor: "primary.main",
          color: "primary.contrastText",
          flexShrink: 0,
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <Spa fontSize="small" />
          <Typography variant="subtitle1" fontWeight="medium">
            {title}
          </Typography>
          <BetaFeatureChip />
        </Box>
        <Button
          size="small"
          onClick={handleExpand}
          endIcon={<ArrowForward fontSize="small" sx={{ mt: -0.25 }} />}
          sx={{ color: "inherit" }}
        >
          Go to messages
        </Button>
      </Box>
      <Box sx={{ flex: 1, overflow: "hidden" }}>
        <AssistantChat
          initialContext={context}
          mode="card"
          onConversationId={setConversationId}
        />
      </Box>
    </Card>
  );
};
